import React from "react";
import { useUser } from "~/Auth/useUser";
import { CommandAuthorization, MenuAuthorizations } from "~/gql/types2";

type IfAuthorizedProps = {
  menu?: MenuAuthorizations;
  command?: CommandAuthorization;
};

export const IfAuthorized: React.FC<IfAuthorizedProps> = ({
  children,
  menu,
  command,
}) => {
  const { menus, commands } = useUser();

  if (menu && !menus.has(menu)) {
    return null;
  }
  if (command && !commands.has(command)) {
    return null;
  }

  return <>{children}</>;
};
